import { createApp } from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import { store } from "./store/store.js";
import "@/assets/css/tailwind.css";
import "@/assets/scss/style.scss";
import "@/assets/scss/layout.scss";
import ldiComponents from "@emtecpoc/componentlibrary";
import PrimeVue from "primevue/config";
import "primeflex/primeflex.css";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ScrollPanel from "primevue/scrollpanel";
import Dialog from "primevue/dialog";
import RadioButton from "primevue/radiobutton";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Skeleton from "primevue/skeleton";
import SelectButton from "primevue/selectbutton";
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "vue-select/dist/vue-select.css";
import ToastService from "primevue/toastservice";
import vSelect from "vue-select";
import Tooltip from "primevue/tooltip";
import emitter from "@/emitter";
import ConfirmationService from 'primevue/confirmationservice';
import { createPinia } from "pinia";
import permDirective from "@/directives/permission.js";
import Clarity from '@microsoft/clarity';

const pinia = createPinia();
const app = createApp(App);

const clarityProjectId = process.env.VUE_APP_CLARITY_PROJECT_ID;
if (clarityProjectId) {
    Clarity.init(clarityProjectId);
}

app.component("InputText", InputText);
app.component("Button", Button);
app.component("ScrollPanel", ScrollPanel);
app.component("Dialog", Dialog);
app.component("RadioButton", RadioButton);
app.component("Checkbox", Checkbox);
app.component("Dropdown", Dropdown);
app.component("Calendar", Calendar);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Skeleton", Skeleton);
app.component("SelectButton", SelectButton);
app.component("v-select", vSelect);
app.use(pinia);
app.use(store);
app.use(router);
app.use(ldiComponents);
app.use(PrimeVue);
app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);
app.directive("perm", permDirective);
app.config.globalProperties.emitter = emitter;
app.mount("#app");
